var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-list"},[_c('h3',{staticClass:"disabled-reg"},[_vm._v(_vm._s(_vm.mainText))]),_c('span',{staticClass:"primary"},[_vm._v(_vm._s(_vm.subText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }